import React from 'react'
import { useSelector } from 'react-redux'
import {
    Avatar,
    Box,
    Popover,
    List,
    ListItem,
    ListItemText,
    IconButton,
    Typography,
    Divider,
} from '@mui/material'
import { Link } from 'react-router-dom'
import { USER_PROP } from 'pages/User/constants'
import { getAuthorizedRoutes } from 'components/app/Validations'
import { mobileUserSettings } from 'components/app/constants'

import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import SwapVertIcon from '@mui/icons-material/SwapVert'
import appActions from '../../app/actions'
import useStyles from './styles.js'

const Header = ({ title, srcLogo, showProfile = false }) => {
    const classes = useStyles()
    const { isHorizontal } = useSelector((state) => state.app)
    const { toggleOrientation } = appActions()
    const { loggedIn, role } = useSelector((state) => state.auth)
    const { user } = useSelector((state) => state.auth)
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <header className={classes.screenHeader}>
            <Typography className={classes.title}>{title}</Typography>
            <Box className={classes.iconsWrapper}>
                {srcLogo && (
                    <IconButton aria-label="logo">
                        <img
                            className={classes.asu}
                            alt="asu-logo"
                            src={srcLogo}
                        />
                    </IconButton>
                )}
                {showProfile && (
                    <IconButton
                        id="screen-toggle"
                        aria-label="toggle-screens-orientation"
                        onClick={toggleOrientation}
                        style={{
                            color: 'white',
                        }}
                        className={classes['toggleOrientation']}
                    >
                        {isHorizontal ? (
                            <SwapVertIcon
                                fontSize="large"
                                className="swap-icon"
                            />
                        ) : (
                            <SwapHorizIcon
                                fontSize="large"
                                className="swap-icon"
                            />
                        )}
                    </IconButton>
                )}
                {showProfile && (
                    <Avatar alt="Logo" onClick={handleClick} sx={{ backgroundColor: '#0a396a' }}>
                        {(user.firstname.toUpperCase()[0] || '') +
                            (user.lastname.toUpperCase()[0] || '')}
                    </Avatar>
                )}
            </Box>
            <Popover
                id={'menu'}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <List disablePadding>
                    <ListItem>
                        <ListItemText primary={`${user.firstname} ${user.lastname}`} secondary={user.email} />
                    </ListItem>
                    <Divider />
                    {getAuthorizedRoutes(
                        mobileUserSettings,
                        loggedIn,
                        role,
                    ).map((link) => (
                        <ListItem
                            button
                            key={link.route}
                            component={Link}
                            to={link.route}
                        >
                            <ListItemText primary={link.text} />
                        </ListItem>
                    ))}
                </List>
            </Popover>
        </header>
    )
}

export default Header
